// extracted by mini-css-extract-plugin
export default {"primary":"giveaway-landing-catalog-subtitle__primary___Rawcq","title":"giveaway-landing-catalog-subtitle__title___iqegL"};